import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../index";
import { PostListState } from "./types";

const slice = (state: RootState) => state.postlist;

export const selectPostListDone = createSelector(slice, (state: PostListState) => state.done);
export const selectPostListLoading = createSelector(slice, (state: PostListState) => state.loading);
export const selectPostListShows = createSelector(slice, (state: PostListState) => state.shows);
